"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _color = _interopRequireDefault(require("color"));
var _cccisdGraphqlTable = _interopRequireDefault(require("cccisd-graphql-table"));
var _cccisdLaravelReport = require("cccisd-laravel-report");
var _bubbleDots = _interopRequireDefault(require("cccisd-icons/bubble-dots3"));
var _plus = _interopRequireDefault(require("cccisd-icons/plus2"));
var _minus = _interopRequireDefault(require("cccisd-icons/minus2"));
var _menu = _interopRequireDefault(require("cccisd-icons/menu7"));
var _spinner = _interopRequireDefault(require("cccisd-icons/spinner8"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var Comment = function Comment(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].commentWrapper
  }, props.data.some(function (d) {
    return d.teenComment || d.caregiverComment;
  }) ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].info
  }, "One thing I learned from SAAF Teen is..."), props.data.map(function (p) {
    if (p.teenComment || p.caregiverComment) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].commentBox,
        key: p.id
      }, /*#__PURE__*/_react["default"].createElement("span", {
        style: {
          fontWeight: 'bold',
          fontSize: '1.1em'
        }
      }, p.participantName), p.teenComment && /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].commentBlock
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].commentHeading
      }, "Teen Comment"), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].comment
      }, p.teenComment)), p.caregiverComment && /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].commentBlock
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].commentHeading
      }, "Caregiver Comment"), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].comment
      }, p.caregiverComment)));
    }
    return null;
  })) : /*#__PURE__*/_react["default"].createElement("div", null, "No comments have been entered for this group."));
};
var Component = function Component(props) {
  var _useState = (0, _react.useState)(true),
    _useState2 = _slicedToArray(_useState, 2),
    boxOpen = _useState2[0],
    setBoxOpen = _useState2[1];
  var title = props.settings.title;
  var colors = props.colors;
  var _renderCommentBox = function _renderCommentBox(data) {
    return /*#__PURE__*/_react["default"].createElement(Comment, {
      data: data
    });
  };
  var renderComments = function renderComments(tableProps) {
    if (!tableProps.loading) {
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdLaravelReport.BrowserOnly, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "btn-group",
        style: {
          marginBottom: '0.7em'
        }
      }, /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "btn btn-sm btn-default dropdown-toggle ".concat(_style["default"].multipurposeButton, " ").concat(tableProps.loading ? _style["default"].rotating : ''),
        "data-toggle": "dropdown",
        "aria-haspopup": "true",
        "aria-expanded": "false"
      }, tableProps.loading ? /*#__PURE__*/_react["default"].createElement(_spinner["default"], null) : /*#__PURE__*/_react["default"].createElement(_menu["default"], null)), /*#__PURE__*/_react["default"].createElement("ul", {
        className: "dropdown-menu"
      }, /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement("a", {
        href: "",
        onClick: tableProps.loadData
      }, "Reload data"))))), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].wrapper,
        style: colors ? {
          borderColor: colors.primary
        } : {}
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].header,
        style: colors ? {
          backgroundColor: colors.primary
        } : {}
      }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_bubbleDots["default"], {
        spaceRight: true
      }), title), /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "btn btn-sm ".concat(_style["default"].menuButton),
        onClick: function onClick() {
          return setBoxOpen(!boxOpen);
        },
        style: colors ? {
          backgroundColor: (0, _color["default"])(colors.primary).darken(0.2)
        } : {}
      }, boxOpen ? /*#__PURE__*/_react["default"].createElement(_minus["default"], null) : /*#__PURE__*/_react["default"].createElement(_plus["default"], null))), boxOpen ? _renderCommentBox(props.convertDataStructure(tableProps.data)) : null));
    }
    return null;
  };
  return /*#__PURE__*/_react["default"].createElement(_cccisdGraphqlTable["default"], {
    graphqlVariables: {
      groupIds: props.filters.groupIds,
      startDate: props.filters.startDate,
      endDate: props.filters.endDate
    },
    query: props.query,
    columns: [],
    render: renderComments
  });
};
Component.propTypes = {
  settings: _propTypes["default"].object,
  data: _propTypes["default"].array,
  query: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  colors: _propTypes["default"].object,
  convertDataStructure: _propTypes["default"].func,
  filters: _propTypes["default"].object
};
Component.defaultProps = {
  convertDataStructure: function convertDataStructure(data) {
    // console.log(data);
    var convertedData = [];
    if (data.length > 0) {
      convertedData = data.map(function (participant) {
        var teenCommentObject = participant.teenList.find(function (i) {
          return i.deployment.label === 'Post Treatment';
        });
        var caregiverCommentObject = participant.caregiverList.find(function (i) {
          return i.deployment.label === 'Post Treatment';
        });
        return {
          id: participant['pawn.pawnId'],
          participantName: participant['fields.participantId'],
          teenComment: teenCommentObject ? teenCommentObject.devTags.YouthPostComment : '',
          caregiverComment: caregiverCommentObject ? caregiverCommentObject.devTags.CaregiverPostComment : ''
        };
      });
    } else {
      convertedData = [{
        id: 1,
        participantName: 'Teen One',
        teenComment: 'I learned a lot.',
        caregiverComment: 'Talking to my teen about racism is important.'
      }, {
        id: 2,
        participantName: 'Teen Two',
        teenComment: 'Teen Two Teen Comment.',
        caregiverComment: 'Teen Two Caregiver Comment'
      }];
    }
    return convertedData;
  }
};
var _default = exports["default"] = Component;